import {
  Box,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import {
  ScreenError,
  ScreenWrap,
  SearchInput,
  SelectInput,
  SoloLoading,
} from '../../components';
import B2BTeamsRow from './B2BTeamsRow';
import useModifiableParams from '../../hooks/use-modifiable-params';
import { Api } from '../../api';
import { useAuthUser } from '../../hooks';

export default function B2BTeamsListScreen() {
  const user = useAuthUser();

  const {
    getParams,
    setModifiedParams,
    tablePaginationProps,
    tableSortLabelProps,
  } = useModifiableParams();

  const params = getParams();

  const api = Api.OrganisationTeam.useReadCollectionUserSub(user.id, params);

  return (
    <ScreenWrap>
      <Stack spacing={3} alignItems="stretch">
        <Typography variant="h4" component="h1">
          Your B2B Teams
        </Typography>
        <Stack
          direction="row"
          alignItems="end"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <Box minWidth={663}>
            <SearchInput
              label="Search"
              value={params.search || ''}
              onChange={(e) =>
                setModifiedParams({ search: e.target.value, page: '1' })
              }
              placeholder="Search by name"
            />
          </Box>
          <SelectInput
            label="Program Status"
            options={[
              { label: 'All', value: '' },
              { label: 'Not Started', value: 'not-started' },
              { label: 'In Progress', value: 'in-progress' },
              { label: 'Finished', value: 'finished' },
            ]}
            labelId="program-status"
            value={params.programStatus || ''}
            onChange={(value) =>
              setModifiedParams({ programStatus: value, page: '1' })
            }
          />
        </Stack>

        <Stack spacing={2}>
          <Card>
            {api.error ? (
              <ScreenError {...api} />
            ) : api.data?.member ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>
                        <TableSortLabel
                          {...tableSortLabelProps('programStartDate')}
                        >
                          Program Start Date
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>Program Status</TableCell>
                      <TableCell>Active Members</TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {api.data.member.map((team) => (
                      <B2BTeamsRow key={team.name} team={team} />
                    ))}
                  </TableBody>
                  <TableFooter
                    sx={{
                      borderTop: '1px solid rgba(224, 224, 224, 1)',
                    }}
                  >
                    <TableRow>
                      <TablePagination
                        {...tablePaginationProps({
                          totalItems: api.data?.totalItems ?? 0,
                          rowsPerPage: 10,
                        })}
                        count={api.data?.totalItems ?? 0}
                        colSpan={5}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            ) : (
              <SoloLoading />
            )}
          </Card>
        </Stack>
      </Stack>
    </ScreenWrap>
  );
}
